// extracted by mini-css-extract-plugin
export default {"container":"index_container__c5cIJ","poster":"index_poster__81HE9","video":"index_video__TzbT0","muted":"index_muted__XU7lL","playBtn":"index_playBtn__IZkT6"};